/**
 * Arabic for the apron view on Stands and gates. Proposed; pending native
 * aviation review. Stand numbers, gate numbers and flight designators are
 * kept as written.
 */
const ar: Record<string, string> = {
  "Apron view": "عرض الساحة",
  "the stands where they are on the aerodrome plan — drag a flight onto a stand, or pick a flight and then a stand":
    "المواقف في أماكنها على مخطط المطار — اسحب رحلة إلى موقف، أو اختر رحلة ثم موقفاً",
  "Main pier": "الرصيف الرئيسي",
  "North apron": "الساحة الشمالية",
  "West apron": "الساحة الغربية",
  "Whole airfield": "المطار كاملاً",
  "All stands": "كل المواقف",
  "Full screen": "ملء الشاشة",
  "Leave full screen": "الخروج من ملء الشاشة",
  "Main pier, west face": "الرصيف الرئيسي، الواجهة الغربية",
  "Main pier, east face": "الرصيف الرئيسي، الواجهة الشرقية",
  "Which part of the airfield": "أي جزء من المطار",
  "Survey drawing underneath": "مخطط المسح في الخلفية",
  "Flight labels": "أسماء الرحلات",
  "Place them all": "خصّص لها جميعاً",
  "Play the day": "شغّل اليوم",
  "The moment the map shows": "اللحظة التي تعرضها الخريطة",
  "{n} from now": "{n} من الآن",
  "Back to now": "العودة إلى الآن",
  "Drag a flight onto a stand — on the map, the chips or the timeline — or pick a flight and then a stand. With a flight in hand the best three stands are numbered and every stand that will not take it turns red and says why. Drag an aircraft already parked to move it.":
    "اسحب رحلة إلى موقف — على الخريطة أو البطاقات أو الخط الزمني — أو اختر رحلة ثم موقفاً. وأثناء حمل الرحلة تُرقَّم أفضل ثلاثة مواقف، ويحمرّ كل موقف لا يستوعبها ويذكر السبب. واسحب طائرة متوقفة لنقلها.",
  "Waiting for a stand": "بانتظار موقف",
  "Every visit has a stand.": "لكل زيارة موقف.",
  "Apron map": "خريطة الساحة",
  "Runway {r}": "المدرج {r}",
  free: "شاغر",
  occupied: "مشغول",
  "a flight within the hour": "رحلة خلال الساعة",
  "a clash in the plan": "تعارض في الخطة",
  "closed by a work order": "مغلق بأمر عمل",
  "work nearby": "أعمال قريبة",
  "on the drawing, not in the register": "على المخطط، وليس في السجل",
  "In the register, not on the drawing": "في السجل، وليس على المخطط",
  "Stand {code}": "الموقف {code}",
  "Stand {code} is on the drawing but not in the register. Add it first.":
    "الموقف {code} على المخطط وليس في السجل. أضفه أولاً.",
  "{flight} has no time on the record, so there is nothing to hold a stand for.":
    "لا وقت مسجلاً للرحلة {flight}، فلا شيء يُحجز له موقف.",
  "{flight} moved from {from} to {to}.": "نُقلت {flight} من {from} إلى {to}.",
  "{flight} is on stand {to}.": "{flight} على الموقف {to}.",
  "Stand {code} released.": "أُخلي الموقف {code}.",
  "Stand {code} added to the register.": "أُضيف الموقف {code} إلى السجل.",
  "drop on {code}": "أفلِتها على {code}",
  "over a stand to place it": "فوق موقف لوضعها",
  "Put it there anyway?": "هل تضعها هناك رغم ذلك؟",
  "{flight} on stand {code}?": "{flight} على الموقف {code}؟",
  "The stand will not take it cleanly:": "لن يستوعبها الموقف دون مشكلة:",
  "{flight} is on stand {to}, with {n} open.": "{flight} على الموقف {to}، مع {n} قائمة.",
  "Put it there anyway": "ضعها هناك رغم ذلك",
  "A stand for every visit still waiting": "موقف لكل زيارة ما زالت تنتظر",
  "No clear stand for any of them.": "لا موقف خالياً لأي منها.",
  "Nowhere clear for {list}: they stay in the list for a person to decide.":
    "لا مكان خالياً لـ {list}: تبقى في القائمة ليقرر فيها شخص.",
  "Each one is placed before the next is considered, by the register's own order: a contact stand before a remote one, then the smallest stand the aircraft fits.":
    "تُوضع كل واحدة قبل النظر في التالية، بترتيب السجل نفسه: موقف متصل قبل البعيد، ثم أصغر موقف تناسبه الطائرة.",
  "Apply all": "طبّق الكل",
  Undo: "تراجع",
  "{flight} in {n} min": "{flight} خلال {n} دقيقة",
  "zoom to it": "قرّب إليه",
  "up to code {c}": "حتى الفئة {c}",
  "none — passengers are bussed": "لا يوجد — يُنقل الركاب بالحافلات",
  "Not with": "ليس مع",
  "This stand is on the aerodrome plan but not in the stand register, so nothing can be planned on it yet.":
    "هذا الموقف على مخطط المطار وليس في سجل المواقف، فلا يمكن التخطيط عليه بعد.",
  "position read from the aerodrome plan, to about 10 m": "الموقع مقروء من مخطط المطار، بدقة نحو 10 م",
  "position from the survey's label, to about 30 m": "الموقع من تسمية المسح، بدقة نحو 30 م",
  "MARS: one wide position or two narrow, L and R": "MARS: موقع عريض واحد أو موقعان ضيقان، L وR",
  "Not on the aerodrome plan: its position is not known to the map.": "ليس على مخطط المطار: موقعه غير معروف للخريطة.",
  "Add it to the register": "أضفه إلى السجل",
  "Largest aircraft": "أكبر طائرة",
  "Gate (if it has one)": "البوابة (إن وجدت)",
  "Add stand {code}": "أضف الموقف {code}",
  "no time on the record": "لا وقت في السجل",
  "now on": "الآن على",
  "Best stands for it": "أفضل المواقف لها",
  "No stand is clear for the whole visit.": "لا موقف خالٍ طوال الزيارة.",
  "Put it here": "ضعها هنا",
  "Why not the others": "لماذا لا الأخرى",
  "Pick a stand on the map to put it there, or drag it.": "اختر موقفاً على الخريطة لوضعها فيه، أو اسحبها.",
  "{n} problem|{n} problems": "لا مشكلات|مشكلة واحدة|مشكلتان|{n} مشكلات|{n} مشكلة|{n} مشكلة",
  "{n} visit placed.|{n} visits placed.":
    "لم تُخصص أي زيارة.|خُصصت زيارة واحدة.|خُصصت زيارتان.|خُصصت {n} زيارات.|خُصصت {n} زيارة.|خُصصت {n} زيارة.",
};
export default ar;
